import createSvgIcon from '../createSvgIcons'

/**
 * @ignore - internal component.
 */
export default createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M7 4.61777L11.2424 0.463329C11.8732 -0.154443 12.896 -0.154443 13.5269 0.463329C14.1577 1.0811 14.1577 2.08271 13.5269 2.70048L8.90375 7.22778C7.85234 8.2574 6.14766 8.25741 5.09625 7.22778L0.473135 2.70048C-0.157712 2.08271 -0.157712 1.0811 0.473135 0.463329C1.10398 -0.154443 2.12679 -0.154443 2.75763 0.463329L7 4.61777Z"
    fill="currentColor"
  />,
  'InputChevronDown'
)
